import { _enum, array, boolean, schema, string } from "@anna-money/anna-web-lib/serializer";

export enum FlowType {
  Incorporation = "INCORPORATION",
  AcnAbn = "ACN_ABN",
  Abn = "ABN",
  SoleTraderAbn = "SOLE_TRADER_ABN", // not really using on the backend side, need only to show radio button
}

export class UserData extends schema(
  {
    alias: string(),
    currentFlowType: _enum(FlowType, "FlowType").nullish(),
  },
  "UserData",
) {}

export class UserFlowTypeUpdateData extends schema(
  {
    currentFlowType: _enum(FlowType, "FlowType"),
  },
  "UserFlowTypeUpdateData",
) {}

export class UserStatusData extends schema(
  {
    canProceed: boolean(),
    companies: array(string()),
    blockedByOnboarding: boolean(),
  },
  "UserStatusData",
) {}
